'use client';

import { type ComponentPropsWithRef } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';

import styles from './ActionDialogButtons.module.scss';

type ActionDialogButtonsProps = ComponentPropsWithRef<'div'> &
  BaseComponentProps;

export function ActionDialogButtons({
  ref,
  className,
  testId = 'ui-action-dialog-buttons',
  ...rest
}: ActionDialogButtonsProps) {
  return (
    <div
      ref={ref}
      className={classnames(styles['dialog-buttons'], className)}
      data-testid={testId}
      {...rest}
    >
      {rest.children}
    </div>
  );
}
